import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {classNames} from '../../../Support/classNames';
import {Link} from 'react-router-dom';
import {formatISO} from 'date-fns';
import {CreateReportPresenter} from './CreateReportPresenter';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {Button} from '../../../Components/Button';
import {ReportType} from '../../../../Models/ReportType';
import {InfoTooltip} from '../../../Components/Utils/InfoTooltip';

interface OwnProps {
    className?: string;
}

const CreateReportComponent: FunctionComponent<OwnProps & PresenterProps<CreateReportPresenter>> = observer(
    ({className, presenter}) => {
        const queryString = new URLSearchParams();
        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5 className="d-flex justify-content-between align-items-baseline flex-row flex-wrap">
                        <span>Create a report</span>
                    </h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <p>Create a new report to organize and analyze your workouts. Track trends over time or compare workouts across athletes.</p>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label mb-2">
                                    Name
                                </label>
                                <input
                                    className="form-control"
                                    placeholder="Name"
                                    name="name"
                                    type="text"
                                    value={presenter.name}
                                    id="name"
                                    onChange={(e) => presenter.onNameChange(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="description" className="form-label mb-2">
                                    Description
                                </label>
                                <input
                                    className="form-control"
                                    placeholder="Description"
                                    name="description"
                                    type="text"
                                    value={presenter.description}
                                    id="description"
                                    onChange={(e) => presenter.onDescriptionChange(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="type" className="form-label mb-2">
                                    Type
                                    <InfoTooltip className="ms-2" description='Trend is ideal for visualizing many workouts over time. Compare offers more flexibility for in-depth comparisons, but works best with fewer workouts.'/>
                                </label>
                                <select
                                    className="form-select"
                                    name="type"
                                    value={presenter.type}
                                    id="description"
                                    onChange={(e) => presenter.onTypeChange(e.target.value as ReportType)}
                                >
                                    <option key={ReportType.TREND} value={ReportType.TREND}>Trend</option>
                                    <option key={ReportType.COMPARE} value={ReportType.COMPARE}>Compare</option>
                                </select>
                            </div>
                            <div className="d-flex flex-row justify-content-between">
                                <Button
                                    className="btn-primary"
                                    text="Save & view"
                                    disabled={presenter.disabled}
                                    loading={presenter.storing}
                                    onClick={() => presenter.store()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    },
);
export const CreateReport = withPresenter<CreateReportPresenter, OwnProps>(
    (props, component) => new CreateReportPresenter(component.network.report),
    CreateReportComponent,
);
